export default {
  'pages.covenantDevice.mac': 'Adresse MAC',
  'pages.admin.providerCard.config.grpcAddr': 'Adresse gRPC',
  'pages.covenantDevice.cardTitle': 'Gestion des périphériques contractuels',
  'pages.admin.whitelist.mac': 'Adresse MAC',
  'pages.covenantDevice.operations': 'Opérations',
  'pages.covenantDevice.expireTime': 'Date d\'expiration',
  'pages.covenantDevice.updateTime': 'Heure de mise à jour',
  'pages.unbindDevice.titleAdmin': 'Délier l\'appareil (Admin requis)',
  'pages.unbindDevice.inputPlaceholder': 'Veuillez entrer l\'ID de l\'appareil',
  'pages.unbindDevice.unbind': 'Délier',
  'pages.unbindDevice.unbinding': 'Déliage...',
  'pages.unbindDevice.success': 'Déliage réussi',
  'pages.unbindDevice.fail': 'Déliage échoué',
  'pages.layouts.userLayout.title': 'Console de gestion',
  'pages.login.accountLogin.tab': 'Connexion au compte',
  'pages.login.accountLogin.errorMessage':
    'Nom d\'utilisateur/mot de passe incorrect (admin/ant.design)',
  'pages.login.failure': 'Échec de la connexion, veuillez réessayer !',
  'pages.login.success': 'Connexion réussie !',
  'pages.login.username.placeholder': 'Nom d\'utilisateur : admin ou utilisateur',
  'pages.login.username.required': 'Veuillez saisir votre nom d\'utilisateur !',
  'pages.login.password.placeholder': 'Mot de passe : ant.design',
  'pages.login.password.required': 'Veuillez saisir votre mot de passe !',
  'pages.login.phoneLogin.tab': 'Connexion par téléphone',
  'pages.login.phoneLogin.errorMessage': 'Erreur de code de vérification',
  'pages.login.phoneNumber.placeholder': 'Numéro de téléphone',
  'pages.login.phoneNumber.required': 'Veuillez saisir votre numéro de téléphone !',
  'pages.login.phoneNumber.invalid': 'Le numéro de téléphone est invalide !',
  'pages.login.captcha.placeholder': 'Code de vérification',
  'pages.login.captcha.required': 'Veuillez saisir le code de vérification !',
  'pages.login.phoneLogin.getVerificationCode': 'Obtenir le code',
  'pages.getCaptchaSecondText': 'sec.',
  'pages.login.rememberMe': 'Se souvenir de moi',
  'pages.login.forgotPassword': 'Mot de passe oublié ?',
  'pages.login.submit': 'Se connecter',
  'pages.login.loginWith': 'Se connecter avec :',
  'pages.login.registerAccount': 'Créer un compte',
  'pages.welcome.link': 'Bienvenue',
  'pages.welcome.alertMessage':
    'Des composants robustes plus rapides et plus puissants ont été publiés.',
  'pages.404.subTitle': 'Désolé, la page que vous avez visitée n\'existe pas.',
  'pages.404.buttonText': 'Retour à l\'accueil',
  'pages.admin.subPage.title': 'Cette page ne peut être visualisée que par l\'administrateur',
  'pages.admin.subPage.alertMessage':
    'Umi ui est maintenant publié, bienvenue à utiliser npm run ui pour commencer l\'expérience.',
  'pages.searchTable.createForm.newRule': 'Nouvelle règle',
  'pages.searchTable.updateForm.ruleConfig': 'Configuration de la règle',
  'pages.searchTable.updateForm.basicConfig': 'Informations de base',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Nom de la règle',
  'pages.searchTable.updateForm.ruleName.nameRules':
    'Veuillez saisir le nom de la règle !',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Description de la règle',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    'Veuillez saisir au moins cinq caractères',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'Veuillez saisir une description de règle d\'au moins cinq caractères !',
  'pages.searchTable.updateForm.ruleProps.title': 'Configurer les propriétés',
  'pages.searchTable.updateForm.object': 'Objet de surveillance',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Modèle de règle',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Type de règle',
  'pages.searchTable.updateForm.schedulingPeriod.title':
    'Définir la période de planification',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Heure de début',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    'Veuillez choisir une heure de début !',
  'pages.searchTable.titleDesc': 'Description',
  'pages.searchTable.ruleName': 'Le nom de la règle est requis',
  'pages.searchTable.titleCallNo': 'Nombre d\'appels de service',
  'pages.searchTable.titleStatus': 'Statut',
  'pages.searchTable.nameStatus.default': 'défaut',
  'pages.searchTable.nameStatus.running': 'en cours',
  'pages.searchTable.nameStatus.online': 'en ligne',
  'pages.searchTable.nameStatus.abnormal': 'anormal',
  'pages.searchTable.titleUpdatedAt': 'Dernière planification à',
  'pages.searchTable.exception': 'Veuillez saisir la raison de l\'exception !',
  'pages.searchTable.titleOption': 'Option',
  'pages.searchTable.config': 'Configuration',
  'pages.searchTable.subscribeAlert': 'S\'abonner aux alertes',
  'pages.searchTable.title': 'Formulaire d\'enquête',
  'pages.searchTable.new': 'Nouveau',
  'pages.searchTable.chosen': 'choisi',
  'pages.searchTable.item': 'élément',
  'pages.searchTable.totalServiceCalls': 'Nombre total d\'appels de service',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'suppression en lot',
  'pages.searchTable.batchApproval': 'approbation en lot',
  
  // Agents page related text
  'pages.agents.search.placeholder': 'Rechercher des agents',
  'pages.agents.create.button': 'Créer un agent',
  'pages.agents.addDevice.button': 'Ajouter un appareil',
  'pages.agents.create.modal.title': 'Créer un agent',
  'pages.agents.create.modal.nameLabel': 'Nom de l\'agent',
  'pages.agents.create.modal.placeholder': 'Veuillez saisir le nom de l\'agent',
  'pages.agents.card.id': 'ID',
  'pages.agents.card.voiceModel': 'Modèle vocal',
  'pages.agents.card.languageModel': 'Modèle de langue',
  'pages.agents.card.lastChat': 'Dernier chat',
  'pages.agents.card.conversationId': 'ID de conversation',
  'pages.agents.card.clearConversation': 'Effacer l\'ID de conversation',
  'pages.agents.card.clearConversation.success': 'ID de conversation effacé',
  'pages.agents.card.clearConversation.error': 'Échec de l\'effacement de l\'ID de conversation',
  'pages.agents.card.configRole': 'Configurer le rôle',
  'pages.agents.card.voiceRecognition': 'Reconnaissance vocale',
  'pages.agents.card.voiceRecognition.developing': 'Fonctionnalité en développement, restez à l\'écoute',
  'pages.agents.card.historyDialog': 'Dialogue historique',
  'pages.agents.card.manageDevice': 'Gérer les appareils',
  'pages.agents.card.addDevice': 'Ajouter un appareil',
  'pages.agents.loading': 'Chargement de la liste des agents...',
  'pages.agents.reload': 'Recharger',
  'pages.agents.empty.title': 'Aucun agent disponible',
  'pages.agents.empty.createFirst': 'Créez votre premier agent',
  'pages.agents.delete.title': 'Confirmer la suppression de l\'agent',
  'pages.agents.delete.content': 'Après avoir supprimé l\'agent, toutes les configurations associées (y compris les enregistrements de conversation liés à l\'appareil) ne peuvent pas être récupérées. Êtes-vous sûr de vouloir supprimer ?',
  'pages.agents.delete.confirm': 'Confirmer la suppression',
  'pages.agents.fetch.error': 'Échec de la récupération de la liste des agents',
  'pages.agents.network.error': 'Erreur réseau, veuillez réessayer plus tard',
  'pages.agents.speed.patient': 'Patient',
  'pages.agents.speed.normal': 'Normal',
  'pages.agents.speed.fast': 'Rapide',
  'pages.agents.lastChat.none': 'Aucun',
  'pages.agents.language.chinese': 'Chinois',
  'pages.agents.loading.tts.error': 'Échec du chargement des voix TTS',
  'pages.agents.loading.llm.error': 'Échec du chargement des fournisseurs LLM',
  'pages.agents.sort.id': 'Trier par ID',
  'pages.agents.sort.updatedAt': 'Trier par dernière modification',
  'pages.agents.sort.lastConversationAt': 'Trier par dernière conversation',
  
  // Register page related text
  'pages.register': 'S\'inscrire',
  'pages.register.title': 'S\'inscrire',
  'pages.register.form.title': 'Créer un nouveau compte',
  'pages.register.submit': 'S\'inscrire',
  'pages.register.username.placeholder': 'Veuillez saisir le nom d\'utilisateur',
  'pages.register.username.required': 'Veuillez saisir le nom d\'utilisateur !',
  'pages.register.username.min': 'Le nom d\'utilisateur doit comporter au moins 4 caractères',
  'pages.register.email.placeholder': 'Veuillez saisir l\'email',
  'pages.register.email.required': 'Veuillez saisir l\'email !',
  'pages.register.email.invalid': 'Veuillez saisir une adresse email valide !',
  'pages.register.password.placeholder': 'Veuillez saisir le mot de passe',
  'pages.register.password.required': 'Veuillez saisir le mot de passe !',
  'pages.register.password.min': 'Le mot de passe doit comporter au moins 6 caractères',
  'pages.register.password.pattern': 'Le mot de passe doit contenir des lettres majuscules, minuscules et des chiffres',
  'pages.register.confirmPassword.placeholder': 'Veuillez confirmer le mot de passe',
  'pages.register.confirmPassword.required': 'Veuillez confirmer le mot de passe !',
  'pages.register.confirmPassword.min': 'Le mot de passe doit comporter au moins 6 caractères',
  'pages.register.error.passwordMismatch': 'Les deux mots de passe ne correspondent pas',
  'pages.register.error.registerFailed': 'Échec de l\'inscription, veuillez réessayer !',
  'pages.register.success': 'Inscription réussie !',
  
  // Login page related text
  'pages.login.title': 'Console de gestion Anime AI Chat',
  'pages.login.actionIcons.notImplemented': 'Pas encore implémenté, bientôt disponible',
  'pages.login.mobile.captchaError': 'Erreur de code de vérification',
  'pages.login.captcha.success': 'Code de vérification envoyé avec succès ! Code : 1234',
  'pages.login.forgotPassword.contactAdmin': 'Veuillez contacter l\'administrateur',
  'pages.login.mobile.notAvailable': 'Cette fonctionnalité n\'est pas encore disponible, veuillez utiliser la connexion par compte',
  
  // AgentSetting page related text
  'pages.agentSetting.title': 'Configurer le rôle',
  'pages.agentSetting.back': 'Retour',
  'pages.agentSetting.roleTemplate.title': 'Modèle de rôle',
  'pages.agentSetting.roleTemplate.label': 'Modèle',
  'pages.agentSetting.template.taiwanGirlfriend': 'Petite amie taïwanaise',
  'pages.agentSetting.template.potato': 'Pomme de terre',
  'pages.agentSetting.template.englishTutor': 'Tuteur d\'anglais',
  'pages.agentSetting.template.curiousBoy': 'Garçon curieux',
  'pages.agentSetting.template.puppyLeader': 'Chef chiot',
  'pages.agentSetting.basicConfig.title': 'Configuration de base',
  'pages.agentSetting.assistantName.label': 'Nom de l\'assistant',
  'pages.agentSetting.assistantName.placeholder': 'Veuillez saisir le nom de l\'assistant',
  'pages.agentSetting.assistantName.required': 'Veuillez saisir le nom de l\'assistant',
  'pages.agentSetting.dialogLanguage.label': 'Langue du dialogue',
  'pages.agentSetting.dialogLanguage.placeholder': 'Sélectionnez la langue du dialogue',
  'pages.agentSetting.voiceType.label': 'Type de voix',
  'pages.agentSetting.voiceType.placeholder': 'Sélectionnez le type de voix',
  'pages.agentSetting.roleDescription.title': 'Description du rôle',
  'pages.agentSetting.roleDescription.label': 'Description du rôle',
  'pages.agentSetting.roleDescription.placeholder': 'Veuillez saisir la description du rôle',
  'pages.agentSetting.roleDescription.required': 'Veuillez saisir la description du rôle',
  'pages.agentSetting.languageModel.title': 'Modèle de langue',
  'pages.agentSetting.languageModel.label': 'Modèle de langue',
  'pages.agentSetting.languageModel.placeholder': 'Sélectionnez le modèle de langue',
  'pages.agentSetting.languageModel.tip': 'Après avoir changé le modèle, il est recommandé d\'effacer la mémoire pour éviter d\'affecter l\'expérience de chat.',
  'pages.agentSetting.advancedSettings.expand': 'Développer les paramètres avancés',
  'pages.agentSetting.advancedSettings.collapse': 'Réduire les paramètres avancés',
  'pages.agentSetting.recognitionSpeed.label': 'Vitesse de reconnaissance vocale',
  'pages.agentSetting.recognitionSpeed.placeholder': 'Sélectionnez la vitesse de reconnaissance',
  'pages.agentSetting.speechSpeed.label': 'Vitesse de parole',
  'pages.agentSetting.speechSpeed.placeholder': 'Sélectionnez la vitesse de parole',
  'pages.agentSetting.pitchValue.label': 'Volume du personnage',
  'pages.agentSetting.button.reset': 'Réinitialiser',
  'pages.agentSetting.button.save': 'Enregistrer',
  'pages.agentSetting.save.success': 'Enregistrement réussi',
  'pages.agentSetting.save.error': 'Échec de l\'enregistrement',
  'pages.agentSetting.save.missingId': 'ID d\'agent manquant, impossible d\'enregistrer',
  'pages.agentSetting.load.tts.error': 'Échec du chargement des voix TTS',
  'pages.agentSetting.speed.slow': 'Lent',
  'pages.agentSetting.speed.normal': 'Normal',
  'pages.agentSetting.speed.fast': 'Rapide',
  'pages.agentSetting.speed.patient': 'Patient',
  'pages.agentSetting.language.chinese': 'Chinois',
  'pages.agentSetting.language.english': 'Anglais',
  'pages.agentSetting.language.spanish': 'Espagnol',
  'pages.agentSetting.language.french': 'Français',
  'pages.agentSetting.language.german': 'Allemand',
  'pages.agentSetting.language.japanese': 'Japonais',
  'pages.agentSetting.language.korean': 'Coréen',
  'pages.agentSetting.language.portuguese': 'Portugais',
  'pages.agentSetting.language.arabic': 'Arabe',
  'pages.agentSetting.language.russian': 'Russe',
  'pages.agentSetting.language.italian': 'Italien',
  'pages.agentSetting.language.turkish': 'Turc',
  'pages.agentSetting.language.polish': 'Polonais',
  'pages.agentSetting.language.catalan': 'Katalanisch',

  // DeviceManagement page related text
  'pages.devices.title': 'Gérer les appareils',
  'pages.devices.breadcrumb.agents': 'Agents',
  'pages.devices.breadcrumb.devices': 'Gérer les appareils',
  'pages.devices.button.addDevice': 'Ajouter un appareil',
  'pages.devices.warning.noAgentId': 'Aucun agentId spécifié, impossible d\'obtenir la liste des appareils',
  'pages.devices.device.unnamed': 'Appareil sans nom',
  'pages.devices.device.macAddress': 'Adresse Mac',
  'pages.devices.device.lastActive': 'Dernière activité',
  'pages.devices.device.firmwareVersion': 'Version du firmware',
  'pages.devices.device.otaUpgrade': 'Mise à niveau OTA',
  'pages.devices.device.noData': 'Aucune donnée',
  'pages.devices.copy.success': 'Adresse MAC copiée',
  'pages.devices.unbind.title': 'Confirmer le déliage de l\'appareil',
  'pages.devices.unbind.content': 'Le déliage de l\'appareil ne peut pas être récupéré. Si vous devez l\'utiliser à nouveau, vous devez le relier. Êtes-vous sûr de le délier ?',
  'pages.devices.unbind.confirm': 'Confirmer le déliage',
  'pages.devices.unbind.cancel': 'Annuler',
  'pages.devices.unbind.success': 'Appareil délié',
  'pages.devices.unbind.error': 'Échec du déliage',
  'pages.devices.ota.enabled': 'Mise à niveau OTA activée',
  'pages.devices.ota.disabled': 'Mise à niveau OTA désactivée',
  
  // HistoryDialogs page related text
  'pages.historyDialogs.title': 'Dialogues historiques',
  'pages.historyDialogs.breadcrumb.agents': 'Agents',
  'pages.historyDialogs.breadcrumb.historyDialogs': 'Dialogues historiques',
  'pages.historyDialogs.empty.title': 'Aucune conversation sélectionnée',
  'pages.historyDialogs.empty.description': 'Veuillez sélectionner une conversation',
  'pages.historyDialogs.agent': 'Agent',
  'pages.historyDialogs.agent.id': 'id',
  'pages.historyDialogs.conversationDetail': 'Détails de la conversation',
  'pages.historyDialogs.selectConversation': 'Veuillez sélectionner une conversation',
  'pages.historyDialogs.delete.title': 'Supprimer la conversation',
  'pages.historyDialogs.delete.content': 'La conversation ne peut pas être récupérée après suppression. Veuillez confirmer l\'opération.',
  'pages.historyDialogs.delete.confirm': 'Confirmer',
  'pages.historyDialogs.delete.cancel': 'Annuler',
  'pages.historyDialogs.message.delete.confirm': 'Êtes-vous sûr de vouloir supprimer ce message ? Il ne peut pas être récupéré après suppression.',
  'pages.historyDialogs.detail.title': 'Détails de la conversation',
  'pages.historyDialogs.agent.label': 'Agent :',
  'pages.historyDialogs.user.label': 'Utilisateur :',
  'pages.historyDialogs.loading': 'Chargement...',
  'pages.historyDialogs.error.loadFailed': 'Échec du chargement de la liste des conversations',
  'pages.historyDialogs.error.deleteFailed': 'Échec de la suppression de la conversation',
  'pages.historyDialogs.success.deleteSuccess': 'Conversation supprimée avec succès',
  
  // MessageList page related text
  'pages.messageList.empty': 'Aucun message',
  'pages.messageList.user': 'Utilisateur',
  'pages.messageList.ai': 'IA',
  
  // Settings page related text
  'pages.settings.basicInfo.title': 'Informations de base',
  'pages.settings.avatar.label': 'Avatar :',
  'pages.settings.avatar.change': 'Changer l\'avatar',
  'pages.settings.avatar.updateSuccess': 'Avatar mis à jour avec succès',
  'pages.settings.avatar.updateFailed': 'Échec de la mise à jour de l\'avatar',
  'pages.settings.username.label': 'Nom d\'utilisateur :',
  'pages.settings.nickname.label': 'Pseudo :',
  'pages.settings.nickname.change': 'Modifier le pseudo',
  'pages.settings.nickname.modal.title': 'Modifier le pseudo',
  'pages.settings.nickname.form.label': 'Nouveau pseudo',
  'pages.settings.nickname.form.required': 'Veuillez saisir le nouveau pseudo',
  'pages.settings.nickname.form.length': 'La longueur du pseudo doit être de 2 à 20 caractères',
  'pages.settings.nickname.updateSuccess': 'Pseudo mis à jour avec succès',
  'pages.settings.nickname.updateFailed': 'Échec de la mise à jour du pseudo',
  'pages.settings.registerTime.label': 'Heure d\'inscription :',
  'pages.settings.email.label': 'Email :',
  'pages.settings.email.unbind': 'Non lié',
  'pages.settings.email.bind': 'Lier l\'email',
  'pages.settings.email.change': 'Changer l\'email',
  'pages.settings.email.modal.title': 'Lier l\'email',
  'pages.settings.email.modal.changeTitle': 'Changer l\'email',
  'pages.settings.email.form.label': 'Email',
  'pages.settings.email.form.required': 'Veuillez saisir l\'email',
  'pages.settings.email.form.invalid': 'Format d\'email invalide',
  'pages.settings.email.bindSuccess': 'Email lié avec succès',
  'pages.settings.email.bindFailed': 'Échec de la liaison de l\'email',
  'pages.settings.changePassword.title': 'Changer le mot de passe',
  'pages.settings.changePassword.button': 'Changer le mot de passe',
  'pages.settings.changePassword.modal.title': 'Changer le mot de passe',
  'pages.settings.changePassword.oldPassword.label': 'Ancien mot de passe',
  'pages.settings.changePassword.oldPassword.required': 'Veuillez saisir l\'ancien mot de passe',
  'pages.settings.changePassword.newPassword.label': 'Nouveau mot de passe',
  'pages.settings.changePassword.newPassword.required': 'Veuillez saisir le nouveau mot de passe',
  'pages.settings.changePassword.newPassword.min': 'Le nouveau mot de passe doit comporter au moins 6 caractères',
  'pages.settings.changePassword.confirmPassword.label': 'Confirmer le nouveau mot de passe',
  'pages.settings.changePassword.confirmPassword.required': 'Veuillez confirmer le nouveau mot de passe',
  'pages.settings.changePassword.confirmPassword.mismatch': 'Les mots de passe ne correspondent pas',
  'pages.settings.changePassword.success': 'Mot de passe changé avec succès',
  'pages.settings.changePassword.failed': 'Échec du changement de mot de passe',
  'pages.settings.deleteAccount.title': 'Supprimer le compte',
  'pages.settings.deleteAccount.button': 'Supprimer le compte',
  'pages.settings.deleteAccount.confirm.title': 'Confirmer la suppression du compte ?',
  'pages.settings.deleteAccount.confirm.content': 'Cette opération ne peut pas être annulée. Êtes-vous sûr de vouloir supprimer votre compte ?',
  'pages.settings.deleteAccount.confirm.ok': 'Supprimer',
  'pages.settings.deleteAccount.confirm.cancel': 'Annuler',
  'pages.settings.deleteAccount.success': 'Compte supprimé avec succès',
  'pages.settings.deleteAccount.failed': 'Échec de la suppression du compte',
  'pages.settings.profile.fetchFailed': 'Échec de la récupération des informations utilisateur',
  'pages.settings.form.submit': 'Soumettre',
  'pages.settings.password.title': 'Paramètres de mot de passe',
  'pages.settings.basicInfo.username': 'Nom d\'utilisateur',
  'pages.settings.basicInfo.nickname': 'Pseudo',
  'pages.settings.basicInfo.avatar': 'Avatar',
  'pages.settings.basicInfo.editNickname': 'Modifier le pseudo',
  'pages.settings.basicInfo.editNicknameTitle': 'Modifier le pseudo',
  'pages.settings.basicInfo.newNicknameLabel': 'Nouveau pseudo',
  'pages.settings.basicInfo.nicknameChangeSuccess': 'Pseudo changé avec succès',
  'pages.settings.basicInfo.openId': 'OpenID:',
  'pages.settings.submit': 'Soumettre',
  'pages.settings.deleteAccount.confirmTitle': 'Confirmer la suppression du compte',
  'pages.settings.deleteAccount.confirmContent': 'Après avoir supprimé votre compte, toutes vos données seront définitivement supprimées et ne pourront pas être récupérées, et vous ne pourrez plus vous connecter avec ce compte. Veuillez procéder avec prudence !',
  'pages.settings.deleteAccount.cancel': 'Annuler',
  'pages.settings.deleteAccount.confirm': 'Confirmer la suppression',
  
  // Admin Dashboard
  'pages.admin.dashboard.userCount': 'Nombre d\'utilisateurs',
  'pages.admin.dashboard.deviceCount': 'Nombre d\'appareils', 
  'pages.admin.dashboard.agentCount': 'Nombre d\'agents',
  'pages.admin.dashboard.onlineUsers': 'Utilisateurs en ligne',
  'pages.admin.dashboard.sessionDevices': 'Appareils de session',
  'pages.admin.dashboard.memoryUsage': 'Utilisation de la mémoire',
  'pages.admin.dashboard.cpuUsage': 'Utilisation du CPU',
  'pages.admin.dashboard.fetchError': 'Échec de la récupération des données',
  'pages.admin.dashboard.networkError': 'Erreur réseau',

  // Admin User Management
  'pages.admin.user.id': 'ID',
  'pages.admin.user.username': 'Nom d\'utilisateur',
  'pages.admin.user.email': 'Email',
  'pages.admin.user.status': 'Statut',
  'pages.admin.user.status.all': 'Tout',
  'pages.admin.user.status.disabled': 'Désactivé',
  'pages.admin.user.status.normal': 'Normal',
  'pages.admin.user.quotaUsed': 'Quota quotidien utilisé',
  'pages.admin.user.quotaTotal': 'Quota quotidien total',
  'pages.admin.user.createdAt': 'Créé le',
  'pages.admin.user.operations': 'Opérations',
  'pages.admin.user.edit': 'Modifier',
  'pages.admin.user.detail': 'Détail',
  'pages.admin.user.editModal.title': 'Modifier l\'utilisateur',
  'pages.admin.user.status.label': 'Statut de l\'utilisateur',
  'pages.admin.user.status.enable': 'Activer',
  'pages.admin.user.status.disable': 'Désactiver',
  'pages.admin.user.quotaUsed.label': 'Quota quotidien utilisé',
  'pages.admin.user.quotaTotal.label': 'Quota quotidien total',
  'pages.admin.user.email.label': 'Email',
  'pages.admin.user.save.success': 'Enregistrement réussi',
  'pages.admin.user.save.failed': 'Échec de l\'enregistrement',
  'pages.admin.user.list.title': 'Liste des utilisateurs',

  // Admin Model Providers
  'pages.admin.providers.title': 'Gestion des fournisseurs de modèles',
  'pages.admin.providers.total': 'Total {total} fournisseurs',
  'pages.admin.providers.stats': 'ASR : {asr}, TTS : {tts}, LLM : {llm}, VLLLM : {vlllm}',
  'pages.admin.providers.addNew': 'Ajouter un nouveau fournisseur',
  'pages.admin.providers.search.placeholder': 'Rechercher nom du fournisseur, point de terminaison ou modèle...',
  'pages.admin.providers.filter.all': 'Tous les types',
  'pages.admin.providers.filter.asr': 'ASR - Reconnaissance vocale',
  'pages.admin.providers.filter.tts': 'TTS - Synthèse vocale', 
  'pages.admin.providers.filter.llm': 'LLM - Grand modèle de langage',
  'pages.admin.providers.filter.vlllm': 'VLLLM - Modèle de langage de vision',
  'pages.admin.providers.empty.noProviders': 'Aucun fournisseur encore',
  'pages.admin.providers.empty.noMatches': 'Aucun fournisseur correspondant trouvé',
  'pages.admin.providers.empty.addFirst': 'Cliquez sur le bouton ci-dessus pour ajouter votre premier fournisseur de modèle',
  'pages.admin.providers.empty.adjustFilters': 'Essayez d\'ajuster les critères de recherche ou les filtres',
  'pages.admin.providers.type.asr': 'ASR - Reconnaissance vocale',
  'pages.admin.providers.type.tts': 'TTS - Synthèse vocale',
  'pages.admin.providers.type.llm': 'LLM - Grand modèle de langage',
  'pages.admin.providers.type.vlllm': 'VLLLM - Modèle de langage de vision',
  'pages.admin.providers.success.created': 'Fournisseur ajouté avec succès !',
  'pages.admin.providers.success.updated': 'Fournisseur mis à jour avec succès !',
  'pages.admin.providers.success.deleted': 'Fournisseur supprimé avec succès !',
  'pages.admin.providers.success.statusToggled': 'Statut basculé avec succès !',
  'pages.admin.providers.error.createFailed': 'Échec de l\'ajout du fournisseur, veuillez réessayer',
  'pages.admin.providers.error.updateFailed': 'Échec de la mise à jour du fournisseur, veuillez réessayer',
  'pages.admin.providers.error.deleteFailed': 'Échec de la suppression du fournisseur, veuillez réessayer',
  'pages.admin.providers.error.testFailed': 'Test de connexion échoué, veuillez vérifier le réseau ou la configuration',
  'pages.admin.providers.error.toggleFailed': 'Échec du basculement du statut, veuillez réessayer',
  'pages.admin.providers.error.loadFailed': 'Échec du chargement de la liste des fournisseurs, veuillez actualiser la page',

  // Admin Settings
  'pages.admin.settings.title': 'Paramètres système',
  'pages.admin.settings.asr.label': 'Service ASR',
  'pages.admin.settings.asr.placeholder': 'Sélectionner le service ASR',
  'pages.admin.settings.tts.label': 'Service TTS',
  'pages.admin.settings.tts.placeholder': 'Sélectionner le service TTS',
  'pages.admin.settings.llm.label': 'Service LLM',
  'pages.admin.settings.llm.placeholder': 'Sélectionner le service LLM',
  'pages.admin.settings.vlllm.label': 'Service VLLLM',
  'pages.admin.settings.vlllm.placeholder': 'Sélectionner le service VLLLM',
  'pages.admin.settings.prompt.label': 'Paramètres de prompt',
  'pages.admin.settings.prompt.placeholder': 'Veuillez saisir le prompt système...',
  'pages.admin.settings.quickReply.label': 'Mots de réponse rapide',
  'pages.admin.settings.quickReply.placeholder': 'Saisir un nouveau mot de réponse rapide',
  'pages.admin.settings.quickReply.add': 'Ajouter',
  'pages.admin.settings.deleteAudio.label': 'Supprimer l\'audio',
  'pages.admin.settings.deleteAudio.enabled': 'Activé',
  'pages.admin.settings.deleteAudio.disabled': 'Désactivé',
  'pages.admin.settings.usePrivateConfig': 'Utiliser la configuration privée',
  'pages.admin.settings.save': 'Enregistrer la configuration',
  'pages.admin.settings.saving': 'Enregistrement...',
  'pages.admin.settings.reset': 'Réinitialiser',
  'pages.admin.settings.success.saved': 'Configuration enregistrée avec succès !',
  'pages.admin.settings.error.saveFailed': 'Échec de l\'enregistrement de la configuration, veuillez réessayer',
  'pages.admin.settings.error.loadFailed': 'Échec du chargement de la configuration, veuillez actualiser la page et réessayer',


  // Add Device Dialog
  'pages.addDevice.modal.title': 'Ajouter un appareil',
  'pages.addDevice.verificationCode.label': 'Code de vérification :',
  'pages.addDevice.verificationCode.placeholder': 'Veuillez saisir le code de vérification à 6 chiffres de l\'appareil',
  'pages.addDevice.verificationCode.required': 'Veuillez saisir un code de vérification à 6 chiffres',
  'pages.addDevice.verificationCode.error': 'Veuillez saisir un code de vérification à 6 chiffres',

  // Provider Modal
  'pages.admin.providerModal.edit.title': 'Modifier le fournisseur',
  'pages.admin.providerModal.add.title': 'Ajouter un nouveau fournisseur',
  'pages.admin.providerModal.name.label': 'Nom du fournisseur *',
  'pages.admin.providerModal.name.placeholder': 'par ex. : OpenAI, Doubao TTS',
  'pages.admin.providerModal.name.required': 'Veuillez saisir le nom du fournisseur',
  'pages.admin.providerModal.type.label': 'Catégorie de service *',
  'pages.admin.providerModal.subType.label': 'Type spécifique *',
  'pages.admin.providerModal.subType.required': 'Veuillez sélectionner le type spécifique',
  'pages.admin.providerModal.config.title': 'Configuration',
  'pages.admin.providerModal.api.url.label': 'URL de l\'API *',
  'pages.admin.providerModal.api.url.required': 'Veuillez saisir l\'URL de l\'API',
  'pages.admin.providerModal.model.name.label': 'Nom du modèle *',
  'pages.admin.providerModal.model.name.required': 'Veuillez saisir le nom du modèle',
  'pages.admin.providerModal.api.key.label': 'Clé API *',
  'pages.admin.providerModal.api.key.required': 'Veuillez saisir la clé API',
  'pages.admin.providerModal.temperature.label': 'Température (0-2)',
  'pages.admin.providerModal.temperature.error': 'La température doit être entre 0-2',
  'pages.admin.providerModal.maxTokens.label': 'Tokens max',
  'pages.admin.providerModal.maxTokens.error': 'Les tokens max doivent être entre 1-32768',
  'pages.admin.providerModal.topP.label': 'Top-P',
  'pages.admin.providerModal.appid.label': 'ID de l\'app *',
  'pages.admin.providerModal.appid.required': 'Veuillez saisir l\'ID de l\'app',
  'pages.admin.providerModal.accessToken.label': 'Token d\'accès *',
  'pages.admin.providerModal.accessToken.required': 'Veuillez saisir le token d\'accès',
  'pages.admin.providerModal.cluster.label': 'Cluster',
  'pages.admin.providerModal.grpc.host.label': 'Hôte gRPC *',
  'pages.admin.providerModal.grpc.host.required': 'Veuillez saisir l\'adresse de l\'hôte gRPC',
  'pages.admin.providerModal.grpc.port.label': 'Port gRPC *',
  'pages.admin.providerModal.grpc.port.required': 'Veuillez saisir le port gRPC',
  'pages.admin.providerModal.voice.label': 'Voix *',
  'pages.admin.providerModal.voice.required': 'Veuillez saisir le type de voix',
  'pages.admin.providerModal.token.label': 'Token *',
  'pages.admin.providerModal.token.required': 'Veuillez saisir le token',
  'pages.admin.providerModal.websocket.label': 'URL WebSocket *',
  'pages.admin.providerModal.websocket.required': 'Veuillez saisir l\'URL WebSocket',
  'pages.admin.providerModal.siliconflow.apiKey.label': 'Clé API *',
  'pages.admin.providerModal.siliconflow.apiKey.required': 'Veuillez saisir la clé API',
  'pages.admin.providerModal.siliconflow.baseUrl.label': 'URL de l\'API',
  'pages.admin.providerModal.manage.voices': 'Gérer les voix',
  'pages.admin.providerModal.edge.noConfig': 'Microsoft Edge TTS ne nécessite aucune configuration supplémentaire',
  'pages.admin.providerModal.submit.error': 'Échec de la soumission, veuillez réessayer',

  // Provider Card
  'pages.admin.providerCard.status.active': 'Actif',
  'pages.admin.providerCard.status.inactive': 'Hors ligne',
  'pages.admin.providerCard.status.error': 'Erreur',
  'pages.admin.providerCard.status.unknown': 'Inconnu',
  'pages.admin.providerCard.warning.readonly.test': 'Permission lecture seule, impossible de tester le fournisseur',
  'pages.admin.providerCard.warning.readonly.delete': 'Permission lecture seule, impossible de supprimer le fournisseur',
  'pages.admin.providerCard.warning.readonly.edit': 'Permission lecture seule, impossible de modifier le fournisseur',
  'pages.admin.providerCard.warning.readonly.toggle': 'Permission lecture seule, impossible de basculer le statut',
  'pages.admin.providerCard.button.disable': 'Désactiver',
  'pages.admin.providerCard.button.enable': 'Activer',
  'pages.admin.providerCard.button.testing': 'Test en cours...',
  'pages.admin.providerCard.button.test': 'Tester',
  'pages.admin.providerCard.button.edit': 'Modifier',
  'pages.admin.providerCard.button.delete': 'Supprimer',
  'pages.admin.providerCard.delete.title': 'Êtes-vous sûr de vouloir supprimer cet élément ?',
  'pages.admin.providerCard.delete.content': 'Il ne peut pas être récupéré après suppression, veuillez confirmer l\'opération.',
  'pages.admin.providerCard.config.type': 'Type',
  'pages.admin.providerCard.config.apiUrl': 'URL de l\'API',
  'pages.admin.providerCard.config.model': 'Modèle',
  'pages.admin.providerCard.config.apiKey': 'Clé API',
  'pages.admin.providerCard.config.temperature': 'Température',
  'pages.admin.providerCard.config.maxTokens': 'Tokens max',
  'pages.admin.providerCard.config.appid': 'ID de l\'app',
  'pages.admin.providerCard.config.cluster': 'Cluster',
  'pages.admin.providerCard.config.accessToken': 'Token d\'accès',
  'pages.admin.providerCard.config.grpcHost': 'Hôte gRPC',
  'pages.admin.providerCard.config.grpcPort': 'Port gRPC',
  'pages.admin.providerCard.config.voice': 'Voix',
  'pages.admin.providerCard.config.format': 'Format',
  'pages.admin.providerCard.config.token': 'Token',
  'pages.admin.providerCard.config.outputDir': 'Répertoire de sortie',
  'pages.admin.providerCard.voices.supported': 'Voix supportées',
  'pages.admin.providerCard.voices.count': '',
  'pages.admin.providerCard.test.failed': 'Test échoué',

    // OpsManage
  'pages.admin.ops.service.title': 'Gestion des services',
  'pages.admin.ops.upload.button': 'Télécharger le fichier de service',
  'pages.admin.ops.upload.success': 'Fichier de service téléchargé avec succès',
  'pages.admin.ops.upload.error': 'Échec du téléchargement du fichier de service',
  'pages.admin.ops.restart.button': 'Redémarrer le service',
  'pages.admin.ops.restart.confirmTitle': 'Attention : Êtes-vous sûr de vouloir redémarrer le service ?',
  'pages.admin.ops.restart.desc': 'Le redémarrage du service déconnectera toutes les connexions actuelles et rendra le service temporairement indisponible.',
  'pages.admin.ops.restart.warn': 'Cette opération ne fera qu\'arrêter le processus de service actuel. Veuillez vous assurer qu\'un daemon ou un script de redémarrage automatique est configuré sur le serveur, sinon le service ne se rétablira pas automatiquement !',
  'pages.admin.ops.restart.ok': 'Confirmer le redémarrage',
  'pages.admin.ops.restart.cancel': 'Annuler',
  'pages.admin.ops.restart.success': 'Commande de redémarrage du service envoyée',
  'pages.admin.ops.restart.error': 'Échec du redémarrage du service',
  'pages.admin.ops.log.title': 'Visualisation et téléchargement des journaux',
  'pages.admin.ops.web.upload.button': 'Télécharger web.zip',
  'pages.admin.ops.web.upload.success': 'web.zip téléchargé avec succès',
  'pages.admin.ops.web.upload.error': 'Échec du téléchargement de web.zip',
  'pages.admin.ops.web.upload.onlyzip': 'Seuls les fichiers zip sont autorisés',
  'pages.admin.ops.web.update.button': 'Mettre à jour le répertoire web',
  'pages.admin.ops.web.update.success': 'Commande de mise à jour du répertoire web envoyée',
  'pages.admin.ops.web.update.error': 'Échec de la mise à jour du répertoire web',
  'pages.admin.ops.web.upload.onlywebzip': 'Seul un fichier nommé web.zip est autorisé',

  // Recorder Management
  'pages.admin.recorder.title': 'Gestion de l\'enregistreur d\'appareil',
  'pages.admin.recorder.inputDeviceId': 'Veuillez saisir l\'ID de l\'appareil',
  'pages.admin.recorder.inputPlaceholder': 'Veuillez saisir l\'ID de l\'appareil',
  'pages.admin.recorder.search': 'Rechercher',
  'pages.admin.recorder.list.title': 'Liste des enregistreurs',
  'pages.admin.recorder.fetchSuccess': 'Enregistrements de l\'enregistreur récupérés avec succès',
  'pages.admin.recorder.fetchError': 'Échec de la récupération de la liste des enregistreurs',
  'pages.admin.recorder.empty': 'Aucune donnée d\'enregistreur, veuillez saisir l\'ID de l\'appareil pour rechercher',
  'pages.admin.recorder.totalCount': 'Statistiques',
  'pages.admin.recorder.conversationId': 'ID de conversation',

  'pages.agentSetting.mcp.modal.title': 'Paramètres du point de terminaison MCP',
  'pages.agentSetting.mcp.modal.statusLabel': 'Statut du point de terminaison',
  'pages.agentSetting.mcp.modal.online': 'En ligne',
  'pages.agentSetting.mcp.modal.disconnected': 'Déconnecté',
  'pages.agentSetting.mcp.modal.unknown': 'Inconnu',
  'pages.agentSetting.mcp.modal.refresh': 'Actualiser',
  'pages.agentSetting.mcp.modal.enabledServices': 'Services activés',
  'pages.agentSetting.mcp.modal.endpointLabel': 'Adresse du point de terminaison',
  'pages.agentSetting.mcp.modal.endpointDesc': 'Voici ladresse du point de terminaison MCP de lagent.',
  'pages.agentSetting.mcp.modal.docLink': 'Voir la documentation du point de terminaison',
  'pages.agentSetting.mcp.modal.noEndpoint': 'Aucun point de terminaison disponible',
  'pages.agentSetting.mcp.modal.hide': 'Cacher',
  'pages.agentSetting.mcp.title': 'Paramètres MCP', 
  'pages.agentSetting.mcp.customService': 'Service personnalisé',
  'pages.agentSetting.mcp.officialServices': 'Services officiels',
  'pages.agentSetting.mcp.officialServices.placeholder': 'Sélectionner les services officiels',
  'pages.agentSetting.mcp.services.weather': 'Météo',
  'pages.agentSetting.mcp.services.joke': 'Blague',
  'pages.agentSetting.mcp.services.music': 'Musique',
  'pages.agentSetting.mcp.services.news': 'Actualités',
  'pages.agentSetting.mcp.error.missingId': 'ID de lagent manquant, impossible de récupérer le point de terminaison',
  'pages.agentSetting.mcp.error.noEndpoint': 'Impossible de récupérer le point de terminaison du serveur',
'pages.agentSetting.mcp.error.fetchFailed': 'Échec de la récupération du point de terminaison',
  'pages.agentSetting.mcp.button.getEndpoint': 'Obtenir le point de terminaison MCP',

  // Memory settings
  'pages.agentSetting.memory.title': 'Mémoire à court terme',
  'pages.agentSetting.memory.type.label': 'Type de mémoire',
  'pages.agentSetting.memory.type.none': 'Pas de mémoire',
  'pages.agentSetting.memory.type.shortTerm': 'Mémoire à court terme',
  'pages.agentSetting.memory.current.label.short': 'Mémoire actuelle',
  'pages.agentSetting.memory.current.help': 'Regénérée après chaque conversation',
  'pages.agentSetting.memory.clear': 'Effacer la mémoire',
  'pages.agentSetting.memory.clear.tip': 'Mémoire marquée pour effacement, cliquez sur enregistrer pour appliquer',
  'pages.agentSetting.memory.content.label': 'Contenu de la mémoire',
  'pages.agentSetting.memory.content.placeholder': 'Obtenir le dernier contenu de mémoire à court terme de l\'agent',
  'pages.agentSetting.memory.content.editPlaceholder': 'Veuillez entrer le contenu de la mémoire',
  'pages.agentSetting.memory.edit': 'Modifier la mémoire',
  'pages.agentSetting.memory.edit.success': 'Mémoire mise à jour, veuillez enregistrer pour appliquer',
  'pages.agentSetting.memory.edit.save': 'Enregistrer les modifications',
  'pages.agentSetting.memory.edit.cancel': 'Annuler',

  // Boutons et opérations courants
  'pages.common.cancel': 'Annuler',

  // Configuration système
  'pages.admin.systemConfig.roleName': 'Nom du rôle',
  'pages.admin.systemConfig.roleDesc': 'Description du rôle',
  'pages.admin.systemConfig.enabled': 'Statut activé',
  'pages.admin.systemConfig.featureName': 'Nom de la fonctionnalité',
  'pages.admin.systemConfig.featureDesc': 'Description de la fonctionnalité',
  'pages.admin.systemConfig.exitCommand': 'Commande de sortie',
  'pages.admin.systemConfig.mcpName': 'Nom MCP',
  'pages.admin.systemConfig.newNameOptional': 'Nouveau nom (optionnel)',
  'pages.admin.systemConfig.configJson': 'Config JSON',
  'pages.admin.systemConfig.useDeviceCode': 'Utiliser le code de lappareil',
  'pages.admin.systemConfig.quickReply': 'Réponse rapide',
  'pages.admin.systemConfig.shortTermMemory': 'Mémoire à court terme',
  'pages.admin.systemConfig.saveUserAudio': 'Enregistrer les fichiers audio utilisateur',
  'pages.admin.systemConfig.enableWhiteList': 'Activer la liste blanche',
  'pages.admin.systemConfig.speakerDetect': 'Reconnaissance vocale',
  'pages.admin.systemConfig.recorderManagerEnable': 'Activer la gestion de lenregistreur',
  'pages.admin.systemConfig.voiceCloneEnable': 'Activer le clonage vocal',
  'pages.admin.systemConfig.flattenedChatHistory': 'Historique de chat aplati',
  'pages.admin.systemConfig.dialogueHistoryLength': 'Longueur de lhistorique de dialogue',
  'pages.admin.systemConfig.userTotalQuota': 'Quota total de lutilisateur',
  'pages.admin.systemConfig.dailyClearQuota': 'Quota quotidien',
  'pages.admin.systemConfig.checkDeviceModeImmediately': 'Vérifier immédiatement le mode de lappareil',
  'pages.admin.systemConfig.defaultObserverUserOnRegister': 'Rôle dobservateur par défaut pour les nouveaux utilisateurs',
  'pages.admin.systemConfig.status': 'Statut',
  'pages.admin.systemConfig.port': 'Port',
  'pages.admin.systemConfig.udpShowPort': 'Afficher le port',
  'pages.admin.systemConfig.accessToken': 'Jeton daccès',
  'pages.admin.systemConfig.activateText': 'Texte dactivation',
  'pages.admin.systemConfig.logLevel': 'Niveau de journal',
  'pages.admin.systemConfig.logDir': 'Répertoire de journal',
  'pages.admin.systemConfig.logFileName': 'Nom du fichier de journal',

  // Clonage vocal
  'pages.console.voiceClone.name': 'Nom',
  'pages.console.voiceClone.provider': 'Fournisseur',
  'pages.console.voiceClone.mode': 'Mode',
  'pages.console.voiceClone.record': 'Enregistrer',
  'pages.console.voiceClone.upload': 'Télécharger',

  // Reconnaissance vocale
  'pages.console.speakers.name': 'Nom',
  'pages.console.speakers.mode': 'Mode',
  'pages.console.speakers.record': 'Enregistrer',
  'pages.console.speakers.upload': 'Télécharger',

  // Configuration de la page
  'pages.console.settings.email': 'Email',
  'pages.console.settings.oldPassword': 'Ancien mot de passe',
  'pages.console.settings.newPassword': 'Nouveau mot de passe',
  'pages.console.settings.confirmNewPassword': 'Confirmer le nouveau mot de passe',

  // Fournisseur VLLM
  'pages.providers.vllm.maxPixels': 'Pixels maximum',
  'pages.admin.providerModal.copyAsNew': 'Copier comme nouveau fournisseur',

  'pages.unbindDevice.cardTitle': 'Dissociation d\'appareil',
  'pages.whiteList.cardTitle': 'Gestion de la liste blanche',
  'pages.admin.ops.logViewer.previewTitle': 'Aperçu du journal',
  'pages.admin.ops.logViewer.fileName': 'Nom du fichier :',
  'pages.admin.ops.logViewer.lineCount': 'Nombre de lignes :',
  'pages.admin.ops.logViewer.previewBtn': 'Aperçu',
  'pages.admin.ops.logViewer.noContent': 'Aucun contenu disponible',
  'pages.admin.devices': 'Gestion des appareils',
  'pages.admin.unbindDevice': 'Dissociation d\'appareil',
  'pages.admin.deviceManage': 'Gestion des appareils',
  'pages.systemConfig.quickReply': 'Réponse rapide',
  'pages.systemConfig.useShortTermMemory': 'Mémoire à court terme',
  'pages.systemConfig.useShortTermMemory.desc': 'Après activation, le système utilise un mécanisme de mémoire à court terme et la met à jour après chaque tour de conversation. Lorsqu\'il est désactivé, la mémoire à court terme n\'est pas utilisée.',
  'pages.agentSetting.mcp.modal.show': 'Afficher',
  'pages.agentSetting.mcp.modal.copied': 'Copié',
  'pages.agentSetting.mcp.modal.copy': 'Copier',
  'pages.admin.providerModal.model.label': 'Modèle *',
  'pages.admin.providerModal.model.placeholder': 'Veuillez saisir le nom du modèle',
  'pages.admin.providerModal.model.required': 'Veuillez saisir le nom du modèle',
  'pages.admin.providerModal.security.title': 'Paramètres de sécurité',
  'pages.admin.providerModal.appid.placeholder': 'ID de l\'application Doubao',
  'pages.admin.providerModal.accessToken.placeholder': 'Jeton d\'accès',
  'pages.admin.providerModal.grpc.addr.label': 'Adresse gRPC (Hôte:Port) *',
  'pages.admin.providerModal.grpc.addr.required': 'Veuillez saisir l\'adresse gRPC (Hôte:Port)',
  'pages.admin.providerModal.token.placeholder': 'Jeton Doubao',
  'pages.admin.providerModal.siliconflow.apiKey.placeholder': 'Clé API',
  'pages.admin.providerModal.manageVoices': 'Gérer les voix',
  'pages.admin.whiteList.inputMac': 'Veuillez saisir l\'adresse MAC',
  'pages.admin.whiteList.batchAdd': 'Ajout par lots',
  'pages.admin.whiteList.add': 'Ajouter',
  'pages.admin.whiteList.list.title': 'Liste des adresses MAC',
  'pages.admin.whiteList.selectCsvTip': 'Veuillez sélectionner un fichier CSV',
  'pages.admin.whiteList.uploadSuccess': 'Téléchargement réussi',
  'pages.admin.whiteList.uploadFailed': 'Échec du téléchargement',
  'pages.admin.whiteList.invalidMac': 'Veuillez saisir une adresse MAC valide',
  'pages.admin.settings.voiceCloneEnable': 'Activer le clonage vocal',
  'pages.agentSetting.roleTemplate.empty': 'Aucun modèle disponible. Veuillez vérifier role_template.json',
  'pages.admin.providerModal.save': 'Enregistrer',
  'pages.contractDevice.cardTitle': 'Gestion des appareils contractuels',
  'pages.contractDevice.mac': 'Adresse MAC',
  'pages.contractDevice.protocolType': 'Type de protocole',
  'pages.contractDevice.status': 'Statut',
  'pages.contractDevice.expireTime': 'Date d\'expiration',
  'pages.contractDevice.updateTime': 'Date de mise à jour',
  'pages.contractDevice.operations': 'Opérations',
  'pages.contractDevice.edit': 'Modifier',
  'pages.contractDevice.delete': 'Supprimer',
  'pages.contractDevice.deleteConfirm': 'Confirmer la suppression',
  'pages.contractDevice.addTitle': 'Ajouter un appareil contractuel',
  'pages.contractDevice.batchAddTitle': 'Ajout par lots',
  'pages.contractDevice.editTitle': 'Modifier l\'appareil contractuel',
  'pages.contractDevice.listTitle': 'Liste des appareils contractuels',
  'pages.contractDevice.add': 'Ajouter',
  'pages.contractDevice.batchAdd': 'Ajout par lots',
  'pages.contractDevice.selectCsvTip': 'Veuillez sélectionner un fichier CSV',
  'pages.contractDevice.uploadSuccess': 'Téléchargement réussi',
  'pages.contractDevice.macRequired': 'Veuillez saisir l\'adresse MAC',
  'pages.contractDevice.protocolTypeRequired': 'Veuillez sélectionner le type de protocole',
  'pages.contractDevice.statusRequired': 'Veuillez sélectionner le statut',
  'pages.contractDevice.expireTimeRequired': 'Veuillez sélectionner la date d\'expiration',
};